import { Product } from '../hooks/useProducts';

interface Category {
  id: string;
  name: string;
  slug: string;
  productCount: number;
  subcategories: Subcategory[];
}

interface Subcategory {
  id: string;
  name: string;
  slug: string;
  productCount: number;
}

interface Seller {
  id: string;
  name: string;
  slug: string;
  subdomain: string;
  verified: boolean;
  yearEstablished: number;
  rating: number;
  totalProducts: number;
  description: string;
  specialties: string[];
  location: string;
}

export const categories: Category[] = [
  {
    id: '1',
    name: 'Garments & Apparel',
    slug: 'garments-apparel',
    productCount: 125,
    subcategories: [
      { id: '1-1', name: 'T-Shirts & Polo Shirts', slug: 't-shirts-polo', productCount: 35 },
      { id: '1-2', name: 'Shirts & Blouses', slug: 'shirts-blouses', productCount: 28 },
      { id: '1-3', name: 'Pants & Trousers', slug: 'pants-trousers', productCount: 22 },
      { id: '1-4', name: 'Dresses & Skirts', slug: 'dresses-skirts', productCount: 20 },
      { id: '1-5', name: 'Traditional Wear', slug: 'traditional-wear', productCount: 20 }
    ]
  },
  {
    id: '2',
    name: 'Jute & Natural Fiber',
    slug: 'jute-natural-fiber',
    productCount: 95,
    subcategories: [
      { id: '2-1', name: 'Jute Bags', slug: 'jute-bags', productCount: 30 },
      { id: '2-2', name: 'Jute Carpets & Rugs', slug: 'jute-carpets-rugs', productCount: 25 },
      { id: '2-3', name: 'Jute Home Decor', slug: 'jute-home-decor', productCount: 20 },
      { id: '2-4', name: 'Natural Fiber Baskets', slug: 'natural-fiber-baskets', productCount: 20 }
    ]
  },
  {
    id: '3',
    name: 'Frozen Foods',
    slug: 'frozen-foods',
    productCount: 75,
    subcategories: [
      { id: '3-1', name: 'Frozen Fish & Seafood', slug: 'frozen-fish-seafood', productCount: 30 },
      { id: '3-2', name: 'Frozen Vegetables', slug: 'frozen-vegetables', productCount: 25 },
      { id: '3-3', name: 'Frozen Meat', slug: 'frozen-meat', productCount: 20 }
    ]
  },
  {
    id: '4',
    name: 'Leather Goods',
    slug: 'leather-goods',
    productCount: 85,
    subcategories: [
      { id: '4-1', name: 'Leather Bags', slug: 'leather-bags', productCount: 25 },
      { id: '4-2', name: 'Leather Shoes', slug: 'leather-shoes', productCount: 25 },
      { id: '4-3', name: 'Leather Wallets', slug: 'leather-wallets', productCount: 20 },
      { id: '4-4', name: 'Leather Jackets', slug: 'leather-jackets', productCount: 15 }
    ]
  },
  {
    id: '5',
    name: 'Pharmaceuticals & Health',
    slug: 'pharmaceuticals-health',
    productCount: 65,
    subcategories: [
      { id: '5-1', name: 'Generic Medicines', slug: 'generic-medicines', productCount: 25 },
      { id: '5-2', name: 'Herbal Products', slug: 'herbal-products', productCount: 20 },
      { id: '5-3', name: 'Medical Equipment', slug: 'medical-equipment', productCount: 20 }
    ]
  },
  {
    id: '6',
    name: 'Scrap & Recycling',
    slug: 'scrap-recycling',
    productCount: 55,
    subcategories: [
      { id: '6-1', name: 'Metal Scrap', slug: 'metal-scrap', productCount: 20 },
      { id: '6-2', name: 'Plastic Scrap', slug: 'plastic-scrap', productCount: 18 },
      { id: '6-3', name: 'Paper Scrap', slug: 'paper-scrap', productCount: 17 }
    ]
  },
  {
    id: '7',
    name: 'Furniture',
    slug: 'furniture',
    productCount: 78,
    subcategories: [
      { id: '7-1', name: 'Wooden Furniture', slug: 'wooden-furniture', productCount: 30 },
      { id: '7-2', name: 'Office Furniture', slug: 'office-furniture', productCount: 25 },
      { id: '7-3', name: 'Home Decor', slug: 'home-decor', productCount: 23 }
    ]
  },
  {
    id: '8',
    name: 'Manpower',
    slug: 'manpower',
    productCount: 62,
    subcategories: [
      { id: '8-1', name: 'Skilled Workers', slug: 'skilled-workers', productCount: 25 },
      { id: '8-2', name: 'Professional Services', slug: 'professional-services', productCount: 20 },
      { id: '8-3', name: 'Labor Services', slug: 'labor-services', productCount: 17 }
    ]
  },
  {
    id: '9',
    name: 'Tourism',
    slug: 'tourism',
    productCount: 45,
    subcategories: [
      { id: '9-1', name: 'Tour Packages', slug: 'tour-packages', productCount: 20 },
      { id: '9-2', name: 'Eco Tourism', slug: 'eco-tourism', productCount: 15 },
      { id: '9-3', name: 'Cultural Tours', slug: 'cultural-tours', productCount: 10 }
    ]
  },
  {
    id: '10',
    name: 'Freelancer',
    slug: 'freelancer',
    productCount: 92,
    subcategories: [
      { id: '10-1', name: 'IT & Programming', slug: 'it-programming', productCount: 35 },
      { id: '10-2', name: 'Design & Creative', slug: 'design-creative', productCount: 30 },
      { id: '10-3', name: 'Digital Marketing', slug: 'digital-marketing', productCount: 27 }
    ]
  }
];

export const sellers: Seller[] = [
  {
    id: '1',
    name: 'Bengal Textiles Ltd.',
    slug: 'bengal-textiles',
    subdomain: 'bengal-textiles.madeinbd.com',
    verified: true,
    yearEstablished: 1995,
    rating: 4.8,
    totalProducts: 156,
    description: 'Leading manufacturer of premium cotton garments with 25+ years of export experience.',
    specialties: ['Cotton T-Shirts', 'Polo Shirts', 'Casual Wear', 'Corporate Uniforms'],
    location: 'Dhaka, Bangladesh'
  },
  {
    id: '2',
    name: 'Heritage Weavers',
    slug: 'heritage-weavers',
    subdomain: 'heritage-weavers.madeinbd.com',
    verified: true,
    yearEstablished: 1988,
    rating: 4.9,
    totalProducts: 89,
    description: 'Traditional handloom weavers specializing in authentic Bangladeshi textiles.',
    specialties: ['Jamdani Sarees', 'Handloom Fabrics', 'Traditional Wear'],
    location: 'Dhaka, Bangladesh'
  },
  {
    id: '3',
    name: 'Eco Jute Co.',
    slug: 'eco-jute',
    subdomain: 'eco-jute.madeinbd.com',
    verified: true,
    yearEstablished: 2001,
    rating: 4.6,
    totalProducts: 134,
    description: 'Sustainable jute product manufacturer focusing on eco-friendly solutions.',
    specialties: ['Jute Bags', 'Eco Products', 'Natural Fiber'],
    location: 'Khulna, Bangladesh'
  },
  {
    id: '4',
    name: 'Sweet Bengal',
    slug: 'sweet-bengal',
    subdomain: 'sweet-bengal.madeinbd.com',
    verified: true,
    yearEstablished: 1992,
    rating: 4.7,
    totalProducts: 67,
    description: 'Premium Bengali sweets and confectionery manufacturer.',
    specialties: ['Traditional Sweets', 'Confectionery', 'Bengali Delicacies'],
    location: 'Cumilla, Bangladesh'
  },
  {
    id: '5',
    name: 'Dhaka Leather Works',
    slug: 'dhaka-leather',
    subdomain: 'dhaka-leather.madeinbd.com',
    verified: true,
    yearEstablished: 1985,
    rating: 4.8,
    totalProducts: 198,
    description: 'Premium leather goods manufacturer with international quality standards.',
    specialties: ['Leather Bags', 'Wallets', 'Shoes', 'Jackets'],
    location: 'Dhaka, Bangladesh'
  },
  {
    id: '6',
    name: 'Bengal Fisheries',
    slug: 'bengal-fisheries',
    subdomain: 'bengal-fisheries.madeinbd.com',
    verified: true,
    yearEstablished: 1990,
    rating: 4.7,
    totalProducts: 89,
    description: 'Leading seafood processor and exporter from Bangladesh.',
    specialties: ['Frozen Fish', 'Seafood', 'Marine Products'],
    location: 'Chittagong, Bangladesh'
  },
  {
    id: '7',
    name: 'Square Pharmaceuticals',
    slug: 'square-pharma',
    subdomain: 'square-pharma.madeinbd.com',
    verified: true,
    yearEstablished: 1958,
    rating: 4.9,
    totalProducts: 234,
    description: 'Leading pharmaceutical company in Bangladesh with WHO-GMP certification.',
    specialties: ['Generic Medicines', 'Healthcare', 'Pharmaceuticals'],
    location: 'Dhaka, Bangladesh'
  },
  {
    id: '8',
    name: 'BD Recycling Co.',
    slug: 'bd-recycling',
    subdomain: 'bd-recycling.madeinbd.com',
    verified: true,
    yearEstablished: 2005,
    rating: 4.4,
    totalProducts: 78,
    description: 'Environmental solutions company specializing in scrap and recycling.',
    specialties: ['Metal Scrap', 'Plastic Recycling', 'Waste Management'],
    location: 'Chittagong, Bangladesh'
  },
  {
    id: '9',
    name: 'Otobi Furniture',
    slug: 'otobi-furniture',
    subdomain: 'otobi.madeinbd.com',
    verified: true,
    yearEstablished: 1975,
    rating: 4.7,
    totalProducts: 120,
    description: 'Leading furniture manufacturer with premium quality wooden and office furniture.',
    specialties: ['Wooden Furniture', 'Office Furniture', 'Home Decor'],
    location: 'Dhaka, Bangladesh'
  },
  {
    id: '10',
    name: 'Bangladesh Manpower Agency',
    slug: 'bd-manpower',
    subdomain: 'bdmanpower.madeinbd.com',
    verified: true,
    yearEstablished: 1998,
    rating: 4.5,
    totalProducts: 85,
    description: 'Premier manpower recruitment agency providing skilled workers globally.',
    specialties: ['Skilled Workers', 'Professional Services', 'Labor Services'],
    location: 'Dhaka, Bangladesh'
  },
  {
    id: '11',
    name: 'Bengal Tours & Travels',
    slug: 'bengal-tours',
    subdomain: 'bengaltours.madeinbd.com',
    verified: true,
    yearEstablished: 2003,
    rating: 4.8,
    totalProducts: 65,
    description: 'Specialized tour operator showcasing the best of Bangladesh to the world.',
    specialties: ['Tour Packages', 'Eco Tourism', 'Cultural Tours'],
    location: 'Dhaka, Bangladesh'
  },
  {
    id: '12',
    name: 'BD Freelancers Hub',
    slug: 'bd-freelancers',
    subdomain: 'bdfreelancers.madeinbd.com',
    verified: true,
    yearEstablished: 2010,
    rating: 4.9,
    totalProducts: 150,
    description: 'Connecting talented Bangladeshi freelancers with global clients.',
    specialties: ['IT & Programming', 'Design & Creative', 'Digital Marketing'],
    location: 'Dhaka, Bangladesh'
  }
];

// Generate 500+ products programmatically
const generateProducts = (): Product[] => {
  const products: Product[] = [];
  let productId = 1;

  // Garments & Apparel - T-Shirts & Polo Shirts (35 products)
  const tshirtNames = [
    'Premium Cotton T-Shirt', 'Polo Shirt Corporate', 'Organic Cotton Tee', 'Sports Performance Tee',
    'V-Neck Cotton Tee', 'Long Sleeve Polo', 'Henley Neck Tee', 'Striped Polo Shirt',
    'Pocket Tee Classic', 'Raglan Sleeve Tee', 'Crew Neck Basic Tee', 'Slim Fit Polo',
    'Graphic Print Tee', 'Tank Top Cotton', 'Polo Shirt Premium', 'Vintage Wash Tee',
    'Moisture Wicking Polo', 'Ringer Tee Classic', 'Pique Polo Shirt', 'Scoop Neck Tee',
    'Athletic Fit Polo', 'Tie Dye T-Shirt', 'Embroidered Polo', 'Muscle Tee Cotton',
    'Contrast Collar Polo', 'Distressed Tee', 'Performance Polo Dry', 'Oversized Tee',
    'Fitted Polo Shirt', 'Burnout Tee', 'Thermal Long Sleeve', 'Mesh Panel Polo',
    'Cropped Tee Women', 'Golf Polo Shirt', 'Bamboo Fiber Tee'
  ];

  tshirtNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((10 + Math.random() * 30) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((15 + Math.random() * 40) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/996329/pexels-photo-996329.jpeg',
      rating: Math.round((3.5 + Math.random() * 1.5) * 10) / 10,
      reviews: Math.floor(20 + Math.random() * 300),
      seller: 'Bengal Textiles Ltd.',
      location: 'Dhaka, Bangladesh',
      badge: Math.random() > 0.7 ? ['Bestseller', 'Premium', 'Eco-Friendly', 'Popular'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Garments & Apparel',
      subcategory: 'T-Shirts & Polo Shirts',
      description: `High-quality ${name.toLowerCase()} with comfortable fit and premium materials`,
      features: ['100% Cotton', 'Pre-shrunk', 'Colorfast', 'Machine Washable'],
      inStock: Math.random() > 0.1
    });
  });

  // Garments & Apparel - Shirts & Blouses (28 products)
  const shirtNames = [
    'Formal Dress Shirt', 'Casual Button Down', 'Linen Summer Shirt', 'Denim Shirt Classic',
    'Flannel Check Shirt', 'Oxford Cotton Shirt', 'Chambray Work Shirt', 'Hawaiian Print Shirt',
    'Plaid Flannel Shirt', 'Poplin Dress Shirt', 'Corduroy Shirt', 'Silk Blouse Elegant',
    'Chiffon Blouse Flowy', 'Cotton Peasant Blouse', 'Wrap Style Blouse', 'Tunic Blouse Long',
    'Sleeveless Blouse', 'Ruffled Front Blouse', 'Tie Front Blouse', 'Bell Sleeve Blouse',
    'Embroidered Boho Blouse', 'Striped Button Shirt', 'Solid Color Blouse', 'Printed Floral Blouse',
    'Work Shirt Utility', 'Western Style Shirt', 'Band Collar Shirt', 'French Cuff Shirt'
  ];

  shirtNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((25 + Math.random() * 50) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((35 + Math.random() * 60) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/996329/pexels-photo-996329.jpeg',
      rating: Math.round((3.5 + Math.random() * 1.5) * 10) / 10,
      reviews: Math.floor(30 + Math.random() * 250),
      seller: 'Bengal Textiles Ltd.',
      location: 'Dhaka, Bangladesh',
      badge: Math.random() > 0.7 ? ['Professional', 'Summer Special', 'Classic', 'Trendy'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Garments & Apparel',
      subcategory: 'Shirts & Blouses',
      description: `Professional ${name.toLowerCase()} perfect for any occasion`,
      features: ['Premium Fabric', 'Wrinkle Resistant', 'Comfortable Fit', 'Easy Care'],
      inStock: Math.random() > 0.1
    });
  });

  // Garments & Apparel - Pants & Trousers (22 products)
  const pantsNames = [
    'Cotton Chino Pants', 'Formal Dress Pants', 'Denim Jeans Classic', 'Cargo Pants Utility',
    'Khaki Trousers', 'Slim Fit Jeans', 'Wide Leg Pants', 'Cropped Pants Summer',
    'Pleated Dress Pants', 'Straight Leg Jeans', 'Bootcut Trousers', 'High Waist Pants',
    'Palazzo Pants Flowy', 'Skinny Fit Jeans', 'Linen Pants Casual', 'Corduroy Pants',
    'Track Pants Athletic', 'Leggings Stretch', 'Capri Pants', 'Jogger Pants Comfort',
    'Tailored Trousers', 'Boyfriend Jeans'
  ];

  pantsNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((30 + Math.random() * 70) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((45 + Math.random() * 85) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/996329/pexels-photo-996329.jpeg',
      rating: Math.round((3.5 + Math.random() * 1.5) * 10) / 10,
      reviews: Math.floor(25 + Math.random() * 200),
      seller: 'Bengal Textiles Ltd.',
      location: 'Dhaka, Bangladesh',
      badge: Math.random() > 0.7 ? ['Comfortable', 'Stylish', 'Versatile', 'Modern'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Garments & Apparel',
      subcategory: 'Pants & Trousers',
      description: `Comfortable ${name.toLowerCase()} with perfect fit and style`,
      features: ['Quality Fabric', 'Perfect Fit', 'Durable', 'Multiple Sizes'],
      inStock: Math.random() > 0.1
    });
  });

  // Garments & Apparel - Dresses & Skirts (20 products)
  const dressNames = [
    'Maxi Dress Floral', 'A-Line Skirt Classic', 'Cocktail Dress Elegant', 'Pencil Skirt Office',
    'Sundress Cotton', 'Pleated Skirt School', 'Evening Gown Formal', 'Mini Skirt Denim',
    'Wrap Dress Casual', 'Circle Skirt Vintage', 'Shift Dress Simple', 'Tutu Skirt Layered',
    'Bodycon Dress Fitted', 'Midi Skirt Flowy', 'Shirt Dress Button', 'Asymmetric Skirt',
    'Slip Dress Silk', 'Cargo Skirt Utility', 'Sweater Dress Knit', 'Tiered Skirt Boho'
  ];

  dressNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((35 + Math.random() * 80) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((50 + Math.random() * 100) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/7148621/pexels-photo-7148621.jpeg',
      rating: Math.round((3.5 + Math.random() * 1.5) * 10) / 10,
      reviews: Math.floor(20 + Math.random() * 180),
      seller: 'Heritage Weavers',
      location: 'Dhaka, Bangladesh',
      badge: Math.random() > 0.7 ? ['Elegant', 'Trendy', 'Feminine', 'Chic'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Garments & Apparel',
      subcategory: 'Dresses & Skirts',
      description: `Beautiful ${name.toLowerCase()} perfect for any occasion`,
      features: ['Flattering Cut', 'Quality Fabric', 'Comfortable Wear', 'Stylish Design'],
      inStock: Math.random() > 0.1
    });
  });

  // Garments & Apparel - Traditional Wear (20 products)
  const traditionalNames = [
    'Handwoven Jamdani Saree', 'Bengali Kurta Men', 'Punjabi Suit Set', 'Dhoti Traditional',
    'Lungi Cotton', 'Panjabi Embroidered', 'Saree Silk Handloom', 'Kurta Pajama Set',
    'Gamcha Traditional', 'Fatua Sleeveless', 'Sharee Party Wear', 'Kurta Long Sleeve',
    'Panjabi Short Sleeve', 'Saree Cotton Handwoven', 'Dhoti Silk', 'Kurta Collar',
    'Panjabi Formal', 'Saree Designer', 'Lungi Checkered', 'Traditional Vest'
  ];

  traditionalNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((40 + Math.random() * 120) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((60 + Math.random() * 150) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/7148621/pexels-photo-7148621.jpeg',
      rating: Math.round((4.0 + Math.random() * 1.0) * 10) / 10,
      reviews: Math.floor(30 + Math.random() * 250),
      seller: 'Heritage Weavers',
      location: 'Dhaka, Bangladesh',
      badge: Math.random() > 0.5 ? ['Authentic', 'Handwoven', 'Traditional', 'Heritage'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Garments & Apparel',
      subcategory: 'Traditional Wear',
      description: `Authentic ${name.toLowerCase()} representing Bengali heritage`,
      features: ['Traditional Design', 'Handcrafted', 'Cultural Heritage', 'Premium Quality'],
      inStock: Math.random() > 0.1
    });
  });

  // Jute & Natural Fiber - Jute Bags (30 products)
  const juteBagNames = [
    'Natural Jute Shopping Bag', 'Jute Tote Bag Large', 'Jute Wine Bag', 'Jute Lunch Bag',
    'Jute Beach Bag', 'Jute Grocery Bag', 'Jute Gift Bag', 'Jute Drawstring Bag',
    'Jute Messenger Bag', 'Jute Backpack', 'Jute Laptop Bag', 'Jute Cosmetic Bag',
    'Jute Picnic Bag', 'Jute Book Bag', 'Jute Travel Bag', 'Jute Shoulder Bag',
    'Jute Handbag', 'Jute Clutch Bag', 'Jute Duffle Bag', 'Jute Gym Bag',
    'Jute Conference Bag', 'Jute Promotional Bag', 'Jute Eco Bag', 'Jute Market Bag',
    'Jute Canvas Bag', 'Jute Burlap Bag', 'Jute Laminated Bag', 'Jute Printed Bag',
    'Jute Colored Bag', 'Jute Designer Bag'
  ];

  juteBagNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((8 + Math.random() * 25) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((12 + Math.random() * 30) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/5217911/pexels-photo-5217911.jpeg',
      rating: Math.round((3.8 + Math.random() * 1.2) * 10) / 10,
      reviews: Math.floor(15 + Math.random() * 150),
      seller: 'Eco Jute Co.',
      location: 'Khulna, Bangladesh',
      badge: Math.random() > 0.6 ? ['Eco-Friendly', 'Sustainable', 'Natural', 'Reusable'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Jute & Natural Fiber',
      subcategory: 'Jute Bags',
      description: `Eco-friendly ${name.toLowerCase()} made from natural jute fiber`,
      features: ['100% Natural Jute', 'Eco-Friendly', 'Reusable', 'Strong Handles'],
      inStock: Math.random() > 0.1
    });
  });

  // Jute & Natural Fiber - Jute Carpets & Rugs (25 products)
  const juteRugNames = [
    'Jute Floor Mat', 'Jute Area Rug', 'Jute Runner Rug', 'Jute Round Rug',
    'Jute Braided Rug', 'Jute Door Mat', 'Jute Kitchen Mat', 'Jute Bathroom Mat',
    'Jute Outdoor Rug', 'Jute Yoga Mat', 'Jute Prayer Rug', 'Jute Carpet Roll',
    'Jute Stair Runner', 'Jute Wall Carpet', 'Jute Exercise Mat', 'Jute Meditation Mat',
    'Jute Floor Covering', 'Jute Entrance Mat', 'Jute Living Room Rug', 'Jute Bedroom Rug',
    'Jute Dining Room Rug', 'Jute Hallway Runner', 'Jute Patio Rug', 'Jute Garden Mat',
    'Jute Anti-Slip Mat'
  ];

  juteRugNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((15 + Math.random() * 60) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((25 + Math.random() * 75) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/5217959/pexels-photo-5217959.jpeg',
      rating: Math.round((3.7 + Math.random() * 1.3) * 10) / 10,
      reviews: Math.floor(20 + Math.random() * 120),
      seller: 'Eco Jute Co.',
      location: 'Khulna, Bangladesh',
      badge: Math.random() > 0.7 ? ['Natural', 'Durable', 'Handwoven', 'Eco-Friendly'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Jute & Natural Fiber',
      subcategory: 'Jute Carpets & Rugs',
      description: `Natural ${name.toLowerCase()} perfect for home decoration`,
      features: ['Natural Jute', 'Non-Slip', 'Durable', 'Easy Clean'],
      inStock: Math.random() > 0.1
    });
  });

  // Jute & Natural Fiber - Jute Home Decor (20 products)
  const juteDecorNames = [
    'Jute Wall Hanging', 'Jute Table Runner', 'Jute Placemats Set', 'Jute Coasters',
    'Jute Lampshade', 'Jute Plant Pot Cover', 'Jute Curtain Tie', 'Jute Photo Frame',
    'Jute Mirror Frame', 'Jute Clock Wall', 'Jute Decorative Bowl', 'Jute Vase Cover',
    'Jute Candle Holder', 'Jute Tissue Box Cover', 'Jute Pen Holder', 'Jute Magazine Rack',
    'Jute Room Divider', 'Jute Wall Art', 'Jute Decorative Panel', 'Jute Hanging Planter'
  ];

  juteDecorNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((10 + Math.random() * 40) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((15 + Math.random() * 50) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/5217959/pexels-photo-5217959.jpeg',
      rating: Math.round((3.6 + Math.random() * 1.4) * 10) / 10,
      reviews: Math.floor(10 + Math.random() * 100),
      seller: 'Eco Jute Co.',
      location: 'Khulna, Bangladesh',
      badge: Math.random() > 0.7 ? ['Handmade', 'Decorative', 'Natural', 'Rustic'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Jute & Natural Fiber',
      subcategory: 'Jute Home Decor',
      description: `Beautiful ${name.toLowerCase()} to enhance your home decor`,
      features: ['Handmade', 'Decorative', 'Natural Look', 'Eco-Friendly'],
      inStock: Math.random() > 0.1
    });
  });

  // Jute & Natural Fiber - Natural Fiber Baskets (20 products)
  const basketNames = [
    'Jute Storage Basket', 'Wicker Laundry Basket', 'Bamboo Fruit Basket', 'Seagrass Storage Basket',
    'Jute Toy Basket', 'Rattan Picnic Basket', 'Jute Bread Basket', 'Water Hyacinth Basket',
    'Jute Magazine Basket', 'Palm Leaf Basket', 'Jute Waste Basket', 'Cane Storage Basket',
    'Jute Organizing Basket', 'Reed Basket Round', 'Jute Hamper Basket', 'Willow Gift Basket',
    'Jute Decorative Basket', 'Grass Weave Basket', 'Jute Utility Basket', 'Natural Fiber Tray'
  ];

  basketNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((12 + Math.random() * 35) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((18 + Math.random() * 45) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/5217959/pexels-photo-5217959.jpeg',
      rating: Math.round((3.8 + Math.random() * 1.2) * 10) / 10,
      reviews: Math.floor(15 + Math.random() * 120),
      seller: 'Eco Jute Co.',
      location: 'Khulna, Bangladesh',
      badge: Math.random() > 0.7 ? ['Storage', 'Handwoven', 'Natural', 'Functional'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Jute & Natural Fiber',
      subcategory: 'Natural Fiber Baskets',
      description: `Versatile ${name.toLowerCase()} for storage and organization`,
      features: ['Storage Solution', 'Natural Fiber', 'Handles', 'Durable'],
      inStock: Math.random() > 0.1
    });
  });

  // Frozen Foods - Frozen Fish & Seafood (30 products)
  const seafoodNames = [
    'Frozen Hilsa Fish', 'Frozen Prawns Large', 'Frozen Rohu Fish', 'Frozen Crab Meat',
    'Frozen Catla Fish', 'Frozen Shrimp Jumbo', 'Frozen Pomfret Fish', 'Frozen Lobster Tail',
    'Frozen Rui Fish', 'Frozen Tiger Prawns', 'Frozen Salmon Fish', 'Frozen Squid Rings',
    'Frozen Tuna Steaks', 'Frozen Mussels', 'Frozen Mackerel Fish', 'Frozen Scallops',
    'Frozen Sardines', 'Frozen Oysters', 'Frozen Cod Fish', 'Frozen Clams',
    'Frozen Tilapia Fish', 'Frozen Octopus', 'Frozen Sea Bass', 'Frozen Cuttlefish',
    'Frozen Kingfish', 'Frozen Crab Legs', 'Frozen Red Snapper', 'Frozen Fish Fillet',
    'Frozen Mixed Seafood', 'Frozen Fish Curry Cut'
  ];

  seafoodNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((15 + Math.random() * 50) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((20 + Math.random() * 60) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/1267320/pexels-photo-1267320.jpeg',
      rating: Math.round((4.0 + Math.random() * 1.0) * 10) / 10,
      reviews: Math.floor(25 + Math.random() * 200),
      seller: 'Bengal Fisheries',
      location: 'Chittagong, Bangladesh',
      badge: Math.random() > 0.6 ? ['Fresh', 'Premium', 'Wild Caught', 'Export Quality'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Frozen Foods',
      subcategory: 'Frozen Fish & Seafood',
      description: `Premium ${name.toLowerCase()} flash frozen for freshness`,
      features: ['Fresh Frozen', 'Premium Quality', 'Wild Caught', 'Vacuum Packed'],
      inStock: Math.random() > 0.1
    });
  });

  // Frozen Foods - Frozen Vegetables (25 products)
  const vegetableNames = [
    'Frozen Mixed Vegetables', 'Frozen Green Peas', 'Frozen Corn Kernels', 'Frozen Spinach',
    'Frozen Broccoli', 'Frozen Cauliflower', 'Frozen Green Beans', 'Frozen Carrots',
    'Frozen Bell Peppers', 'Frozen Okra', 'Frozen Potato Fries', 'Frozen Sweet Corn',
    'Frozen Brussels Sprouts', 'Frozen Asparagus', 'Frozen Edamame', 'Frozen Artichokes',
    'Frozen Zucchini', 'Frozen Mushrooms', 'Frozen Onions Diced', 'Frozen Garlic Paste',
    'Frozen Ginger Paste', 'Frozen Herb Mix', 'Frozen Stir Fry Mix', 'Frozen Soup Mix',
    'Frozen Vegetable Medley'
  ];

  vegetableNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((5 + Math.random() * 20) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((8 + Math.random() * 25) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/1267320/pexels-photo-1267320.jpeg',
      rating: Math.round((3.8 + Math.random() * 1.2) * 10) / 10,
      reviews: Math.floor(20 + Math.random() * 150),
      seller: 'Fresh Freeze BD',
      location: 'Dhaka, Bangladesh',
      badge: Math.random() > 0.7 ? ['Organic', 'Fresh', 'Nutritious', 'Farm Fresh'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Frozen Foods',
      subcategory: 'Frozen Vegetables',
      description: `Fresh ${name.toLowerCase()} flash frozen to preserve nutrients`,
      features: ['Flash Frozen', 'Nutritious', 'Ready to Cook', 'No Preservatives'],
      inStock: Math.random() > 0.1
    });
  });

  // Frozen Foods - Frozen Meat (20 products)
  const meatNames = [
    'Frozen Chicken Breast', 'Frozen Beef Steaks', 'Frozen Lamb Chops', 'Frozen Chicken Wings',
    'Frozen Ground Beef', 'Frozen Pork Ribs', 'Frozen Chicken Thighs', 'Frozen Beef Roast',
    'Frozen Lamb Leg', 'Frozen Chicken Drumsticks', 'Frozen Beef Mince', 'Frozen Pork Chops',
    'Frozen Chicken Whole', 'Frozen Beef Brisket', 'Frozen Lamb Shoulder', 'Frozen Turkey Breast',
    'Frozen Duck Breast', 'Frozen Goat Meat', 'Frozen Chicken Strips', 'Frozen Mixed Meat'
  ];

  meatNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((12 + Math.random() * 40) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((18 + Math.random() * 50) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/1267320/pexels-photo-1267320.jpeg',
      rating: Math.round((4.0 + Math.random() * 1.0) * 10) / 10,
      reviews: Math.floor(30 + Math.random() * 180),
      seller: 'Fresh Freeze BD',
      location: 'Dhaka, Bangladesh',
      badge: Math.random() > 0.6 ? ['Halal', 'Premium', 'Fresh', 'Protein Rich'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Frozen Foods',
      subcategory: 'Frozen Meat',
      description: `Premium ${name.toLowerCase()} frozen for freshness and quality`,
      features: ['Halal Certified', 'Premium Cut', 'Flash Frozen', 'Protein Rich'],
      inStock: Math.random() > 0.1
    });
  });

  // Leather Goods - Leather Bags (25 products)
  const leatherBagNames = [
    'Premium Leather Handbag', 'Leather Laptop Bag', 'Leather Messenger Bag', 'Leather Tote Bag',
    'Leather Backpack', 'Leather Briefcase', 'Leather Crossbody Bag', 'Leather Clutch Bag',
    'Leather Duffle Bag', 'Leather Satchel Bag', 'Leather Travel Bag', 'Leather Shoulder Bag',
    'Leather Camera Bag', 'Leather Document Bag', 'Leather Gym Bag', 'Leather Evening Bag',
    'Leather Hobo Bag', 'Leather Bucket Bag', 'Leather Saddle Bag', 'Leather Weekender Bag',
    'Leather Portfolio Bag', 'Leather Fanny Pack', 'Leather Drawstring Bag', 'Leather Tool Bag',
    'Leather Designer Bag'
  ];

  leatherBagNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((45 + Math.random() * 150) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((65 + Math.random() * 180) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/1152077/pexels-photo-1152077.jpeg',
      rating: Math.round((4.2 + Math.random() * 0.8) * 10) / 10,
      reviews: Math.floor(40 + Math.random() * 250),
      seller: 'Dhaka Leather Works',
      location: 'Dhaka, Bangladesh',
      badge: Math.random() > 0.6 ? ['Premium', 'Handcrafted', 'Genuine', 'Luxury'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Leather Goods',
      subcategory: 'Leather Bags',
      description: `Handcrafted ${name.toLowerCase()} made from genuine leather`,
      features: ['Genuine Leather', 'Handcrafted', 'Multiple Compartments', 'Durable'],
      inStock: Math.random() > 0.1
    });
  });

  // Leather Goods - Leather Shoes (25 products)
  const leatherShoeNames = [
    'Leather Oxford Shoes', 'Leather Loafers', 'Leather Boots', 'Leather Sandals',
    'Leather Dress Shoes', 'Leather Casual Shoes', 'Leather Sneakers', 'Leather Ankle Boots',
    'Leather Derby Shoes', 'Leather Moccasins', 'Leather High Heels', 'Leather Flats',
    'Leather Pumps', 'Leather Wedges', 'Leather Slip-ons', 'Leather Brogues',
    'Leather Chelsea Boots', 'Leather Hiking Boots', 'Leather Work Boots', 'Leather Slippers',
    'Leather Boat Shoes', 'Leather Monk Shoes', 'Leather Platform Shoes', 'Leather Ballet Flats',
    'Leather Combat Boots'
  ];

  leatherShoeNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((55 + Math.random() * 120) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((75 + Math.random() * 150) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/1152077/pexels-photo-1152077.jpeg',
      rating: Math.round((4.1 + Math.random() * 0.9) * 10) / 10,
      reviews: Math.floor(35 + Math.random() * 200),
      seller: 'Dhaka Leather Works',
      location: 'Dhaka, Bangladesh',
      badge: Math.random() > 0.6 ? ['Handcrafted', 'Comfortable', 'Stylish', 'Durable'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Leather Goods',
      subcategory: 'Leather Shoes',
      description: `Comfortable ${name.toLowerCase()} crafted from premium leather`,
      features: ['Genuine Leather', 'Comfortable Fit', 'Durable Sole', 'Stylish Design'],
      inStock: Math.random() > 0.1
    });
  });

  // Leather Goods - Leather Wallets (20 products)
  const walletNames = [
    'Leather Wallet Bifold', 'Leather Wallet Trifold', 'Leather Card Holder', 'Leather Money Clip',
    'Leather Coin Purse', 'Leather Travel Wallet', 'Leather Phone Wallet', 'Leather Checkbook Wallet',
    'Leather Zip Wallet', 'Leather Slim Wallet', 'Leather Long Wallet', 'Leather RFID Wallet',
    'Leather Vintage Wallet', 'Leather Designer Wallet', 'Leather Minimalist Wallet', 'Leather Chain Wallet',
    'Leather Passport Wallet', 'Leather Business Card Holder', 'Leather Key Wallet', 'Leather Envelope Wallet'
  ];

  walletNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((15 + Math.random() * 60) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((25 + Math.random() * 75) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/1152077/pexels-photo-1152077.jpeg',
      rating: Math.round((4.0 + Math.random() * 1.0) * 10) / 10,
      reviews: Math.floor(25 + Math.random() * 180),
      seller: 'Dhaka Leather Works',
      location: 'Dhaka, Bangladesh',
      badge: Math.random() > 0.7 ? ['Compact', 'RFID Protected', 'Handmade', 'Classic'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Leather Goods',
      subcategory: 'Leather Wallets',
      description: `Premium ${name.toLowerCase()} with multiple card slots`,
      features: ['Genuine Leather', 'Multiple Card Slots', 'Bill Compartment', 'Compact'],
      inStock: Math.random() > 0.1
    });
  });

  // Leather Goods - Leather Jackets (15 products)
  const jacketNames = [
    'Leather Biker Jacket', 'Leather Bomber Jacket', 'Leather Blazer', 'Leather Trench Coat',
    'Leather Moto Jacket', 'Leather Varsity Jacket', 'Leather Aviator Jacket', 'Leather Vest',
    'Leather Parka', 'Leather Windbreaker', 'Leather Racing Jacket', 'Leather Casual Jacket',
    'Leather Formal Jacket', 'Leather Vintage Jacket', 'Leather Designer Jacket'
  ];

  jacketNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((120 + Math.random() * 300) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((160 + Math.random() * 350) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/1152077/pexels-photo-1152077.jpeg',
      rating: Math.round((4.3 + Math.random() * 0.7) * 10) / 10,
      reviews: Math.floor(50 + Math.random() * 300),
      seller: 'Dhaka Leather Works',
      location: 'Dhaka, Bangladesh',
      badge: Math.random() > 0.5 ? ['Premium', 'Stylish', 'Warm', 'Fashion'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Leather Goods',
      subcategory: 'Leather Jackets',
      description: `Stylish ${name.toLowerCase()} perfect for any season`,
      features: ['Genuine Leather', 'Warm Lining', 'Stylish Cut', 'Durable Zippers'],
      inStock: Math.random() > 0.1
    });
  });

  // Pharmaceuticals & Health - Generic Medicines (25 products)
  const medicineNames = [
    'Paracetamol Tablets 500mg', 'Ibuprofen Tablets 400mg', 'Aspirin Tablets 75mg', 'Omeprazole Capsules 20mg',
    'Metformin Tablets 500mg', 'Amlodipine Tablets 5mg', 'Atorvastatin Tablets 20mg', 'Losartan Tablets 50mg',
    'Ciprofloxacin Tablets 500mg', 'Amoxicillin Capsules 250mg', 'Diclofenac Tablets 50mg', 'Ranitidine Tablets 150mg',
    'Cetirizine Tablets 10mg', 'Montelukast Tablets 10mg', 'Pantoprazole Tablets 40mg', 'Azithromycin Tablets 500mg',
    'Clopidogrel Tablets 75mg', 'Simvastatin Tablets 20mg', 'Lisinopril Tablets 10mg', 'Gabapentin Capsules 300mg',
    'Tramadol Tablets 50mg', 'Prednisolone Tablets 5mg', 'Fluconazole Tablets 150mg', 'Doxycycline Capsules 100mg',
    'Vitamin D3 Tablets 1000IU'
  ];

  medicineNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((2 + Math.random() * 15) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((3 + Math.random() * 20) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/3683074/pexels-photo-3683074.jpeg',
      rating: Math.round((4.2 + Math.random() * 0.8) * 10) / 10,
      reviews: Math.floor(50 + Math.random() * 200),
      seller: 'Square Pharmaceuticals',
      location: 'Dhaka, Bangladesh',
      badge: Math.random() > 0.6 ? ['Generic', 'WHO Approved', 'Quality', 'Effective'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Pharmaceuticals & Health',
      subcategory: 'Generic Medicines',
      description: `High-quality ${name.toLowerCase()} for effective treatment`,
      features: ['WHO Approved', 'Quality Assured', 'Effective', 'Safe'],
      inStock: Math.random() > 0.1
    });
  });

  // Pharmaceuticals & Health - Herbal Products (20 products)
  const herbalNames = [
    'Vitamin C Tablets', 'Multivitamin Capsules', 'Omega-3 Fish Oil', 'Calcium Tablets',
    'Iron Supplements', 'Zinc Tablets', 'Magnesium Capsules', 'Vitamin B Complex',
    'Probiotics Capsules', 'Turmeric Capsules', 'Ginseng Extract', 'Garlic Capsules',
    'Green Tea Extract', 'Ashwagandha Capsules', 'Spirulina Tablets', 'Moringa Capsules',
    'Neem Capsules', 'Aloe Vera Gel', 'Honey Natural', 'Herbal Tea Mix'
  ];

  herbalNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((5 + Math.random() * 25) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((8 + Math.random() * 30) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/3683074/pexels-photo-3683074.jpeg',
      rating: Math.round((4.0 + Math.random() * 1.0) * 10) / 10,
      reviews: Math.floor(30 + Math.random() * 150),
      seller: 'Square Pharmaceuticals',
      location: 'Dhaka, Bangladesh',
      badge: Math.random() > 0.6 ? ['Natural', 'Herbal', 'Organic', 'Health'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Pharmaceuticals & Health',
      subcategory: 'Herbal Products',
      description: `Natural ${name.toLowerCase()} for health and wellness`,
      features: ['Natural Ingredients', 'Health Benefits', 'No Side Effects', 'Quality Tested'],
      inStock: Math.random() > 0.1
    });
  });

  // Pharmaceuticals & Health - Medical Equipment (20 products)
  const medicalEquipmentNames = [
    'Digital Thermometer', 'Blood Pressure Monitor', 'Pulse Oximeter', 'Glucometer',
    'Stethoscope', 'Nebulizer Machine', 'Weighing Scale Digital', 'First Aid Kit',
    'Wheelchair', 'Walking Stick', 'Compression Stockings', 'Heating Pad',
    'Ice Pack', 'Bandages Elastic', 'Surgical Mask', 'Hand Sanitizer',
    'Disposable Gloves', 'Syringe Disposable', 'Cotton Swabs', 'Medical Tape'
  ];

  medicalEquipmentNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((8 + Math.random() * 150) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((12 + Math.random() * 180) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/3683074/pexels-photo-3683074.jpeg',
      rating: Math.round((4.1 + Math.random() * 0.9) * 10) / 10,
      reviews: Math.floor(25 + Math.random() * 180),
      seller: 'MedTech BD',
      location: 'Dhaka, Bangladesh',
      badge: Math.random() > 0.6 ? ['Digital', 'Accurate', 'Medical Grade', 'Certified'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Pharmaceuticals & Health',
      subcategory: 'Medical Equipment',
      description: `Professional ${name.toLowerCase()} for medical use`,
      features: ['Medical Grade', 'Accurate', 'Easy to Use', 'Certified'],
      inStock: Math.random() > 0.1
    });
  });

  // Scrap & Recycling - Metal Scrap (20 products)
  const metalScrapNames = [
    'Copper Wire Scrap', 'Aluminum Scrap Clean', 'Steel Scrap HMS', 'Brass Scrap Mixed',
    'Iron Scrap Cast', 'Stainless Steel Scrap', 'Lead Scrap Battery', 'Zinc Scrap Die Cast',
    'Nickel Scrap', 'Tin Scrap', 'Bronze Scrap', 'Titanium Scrap',
    'Magnesium Scrap', 'Tungsten Scrap', 'Molybdenum Scrap', 'Cobalt Scrap',
    'Silver Scrap', 'Gold Scrap Electronic', 'Platinum Scrap', 'Palladium Scrap'
  ];

  metalScrapNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((1 + Math.random() * 10) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((1.5 + Math.random() * 12) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/2219024/pexels-photo-2219024.jpeg',
      rating: Math.round((3.8 + Math.random() * 1.2) * 10) / 10,
      reviews: Math.floor(15 + Math.random() * 100),
      seller: 'BD Recycling Co.',
      location: 'Chittagong, Bangladesh',
      badge: Math.random() > 0.7 ? ['Clean Grade', 'Sorted', 'High Purity', 'Bulk'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Scrap & Recycling',
      subcategory: 'Metal Scrap',
      description: `High-grade ${name.toLowerCase()} for recycling`,
      features: ['High Purity', 'Clean Scrap', 'Sorted', 'Bulk Available'],
      inStock: Math.random() > 0.1
    });
  });

  // Scrap & Recycling - Plastic Scrap (18 products)
  const plasticScrapNames = [
    'PET Bottle Scrap', 'HDPE Scrap Clean', 'PP Scrap Mixed', 'LDPE Film Scrap',
    'PVC Scrap Rigid', 'PS Scrap White', 'ABS Scrap Computer', 'PC Scrap Clear',
    'PMMA Scrap Acrylic', 'PA Scrap Nylon', 'POM Scrap Engineering', 'TPU Scrap Flexible',
    'EVA Scrap Foam', 'PBT Scrap Electronic', 'PEEK Scrap High Performance', 'PTFE Scrap Teflon',
    'Plastic Bags Scrap', 'Plastic Containers Scrap'
  ];

  plasticScrapNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((0.3 + Math.random() * 2) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((0.5 + Math.random() * 2.5) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/2219024/pexels-photo-2219024.jpeg',
      rating: Math.round((3.6 + Math.random() * 1.4) * 10) / 10,
      reviews: Math.floor(10 + Math.random() * 80),
      seller: 'BD Recycling Co.',
      location: 'Chittagong, Bangladesh',
      badge: Math.random() > 0.7 ? ['Clean', 'Sorted', 'Recyclable', 'Bulk'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Scrap & Recycling',
      subcategory: 'Plastic Scrap',
      description: `Clean ${name.toLowerCase()} ready for recycling`,
      features: ['Clean Grade', 'Sorted', 'Recyclable', 'Bulk Available'],
      inStock: Math.random() > 0.1
    });
  });

  // Scrap & Recycling - Paper Scrap (17 products)
  const paperScrapNames = [
    'Newspaper Scrap', 'Cardboard Scrap', 'Office Paper Scrap', 'Magazine Scrap',
    'Book Paper Scrap', 'Kraft Paper Scrap', 'Tissue Paper Scrap', 'Packaging Paper Scrap',
    'Corrugated Box Scrap', 'White Paper Scrap', 'Mixed Paper Scrap', 'Coated Paper Scrap',
    'Notebook Paper Scrap', 'Computer Paper Scrap', 'Envelope Scrap', 'Catalog Paper Scrap',
    'Shredded Paper Scrap'
  ];

  paperScrapNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((0.1 + Math.random() * 0.8) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((0.15 + Math.random() * 1) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/2219024/pexels-photo-2219024.jpeg',
      rating: Math.round((3.5 + Math.random() * 1.5) * 10) / 10,
      reviews: Math.floor(8 + Math.random() * 60),
      seller: 'BD Recycling Co.',
      location: 'Chittagong, Bangladesh',
      badge: Math.random() > 0.7 ? ['Clean', 'Sorted', 'Dry', 'Bulk'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Scrap & Recycling',
      subcategory: 'Paper Scrap',
      description: `Clean ${name.toLowerCase()} for paper recycling`,
      features: ['Clean Grade', 'Dry', 'Sorted', 'Bulk Available'],
      inStock: Math.random() > 0.1
    });
  });

  // Furniture - Wooden Furniture (30 products)
  const woodenFurnitureNames = [
    'Wooden Dining Table', 'Wooden Bed Frame', 'Wooden Wardrobe', 'Wooden Coffee Table',
    'Wooden Bookshelf', 'Wooden TV Stand', 'Wooden Sofa Set', 'Wooden Side Table',
    'Wooden Console Table', 'Wooden Dresser', 'Wooden Nightstand', 'Wooden Desk',
    'Wooden Chair Set', 'Wooden Bench', 'Wooden Stool', 'Wooden Cabinet',
    'Wooden Shelving Unit', 'Wooden Chest of Drawers', 'Wooden Shoe Rack', 'Wooden Wine Rack',
    'Wooden Kitchen Island', 'Wooden Dining Chairs', 'Wooden Rocking Chair', 'Wooden Folding Table',
    'Wooden Bunk Bed', 'Wooden Display Cabinet', 'Wooden Room Divider', 'Wooden Bar Stool',
    'Wooden Coat Rack', 'Wooden Wall Shelf'
  ];

  woodenFurnitureNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((80 + Math.random() * 500) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((100 + Math.random() * 600) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/1350789/pexels-photo-1350789.jpeg',
      rating: Math.round((4.0 + Math.random() * 1.0) * 10) / 10,
      reviews: Math.floor(15 + Math.random() * 150),
      seller: 'Otobi Furniture',
      location: 'Dhaka, Bangladesh',
      badge: Math.random() > 0.7 ? ['Premium', 'Handcrafted', 'Solid Wood', 'Durable'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Furniture',
      subcategory: 'Wooden Furniture',
      description: `High-quality ${name.toLowerCase()} made from premium wood`,
      features: ['Premium Wood', 'Durable Construction', 'Stylish Design', 'Easy Assembly'],
      inStock: Math.random() > 0.1
    });
  });

  // Furniture - Office Furniture (25 products)
  const officeFurnitureNames = [
    'Executive Office Desk', 'Ergonomic Office Chair', 'Office Cubicle System', 'Conference Table',
    'Office Filing Cabinet', 'Office Bookshelf', 'Reception Desk', 'Office Sofa',
    'Office Workstation', 'Boardroom Chairs', 'Office Storage Cabinet', 'Office Partition',
    'Standing Desk', 'Office Side Table', 'Office Credenza', 'Visitor Chairs',
    'Office Lounge Furniture', 'Mobile Pedestal', 'Office Whiteboard', 'Office Display Cabinet',
    'Modular Office System', 'Office Coat Stand', 'Office Coffee Table', 'Office Bench',
    'Office Desk Organizer'
  ];

  officeFurnitureNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((100 + Math.random() * 800) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((150 + Math.random() * 900) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/1957477/pexels-photo-1957477.jpeg',
      rating: Math.round((4.0 + Math.random() * 1.0) * 10) / 10,
      reviews: Math.floor(10 + Math.random() * 100),
      seller: 'Otobi Furniture',
      location: 'Dhaka, Bangladesh',
      badge: Math.random() > 0.7 ? ['Ergonomic', 'Professional', 'Modern', 'Durable'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Furniture',
      subcategory: 'Office Furniture',
      description: `Professional ${name.toLowerCase()} for modern office spaces`,
      features: ['Ergonomic Design', 'Premium Materials', 'Professional Look', 'Durable Construction'],
      inStock: Math.random() > 0.1
    });
  });

  // Furniture - Home Decor (23 products)
  const homeDecorNames = [
    'Decorative Wall Mirror', 'Table Lamp', 'Floor Rug', 'Throw Pillows Set',
    'Wall Art Canvas', 'Decorative Vase', 'Curtains Set', 'Photo Frame Set',
    'Floor Lamp', 'Decorative Candle Holder', 'Wall Clock', 'Throw Blanket',
    'Bookends Set', 'Decorative Bowl', 'Plant Stand', 'Floating Shelves',
    'Room Divider Screen', 'Decorative Tray', 'Ottoman Pouf', 'Ceiling Light Fixture',
    'Wall Tapestry', 'Decorative Storage Basket', 'Artificial Plant'
  ];

  homeDecorNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((15 + Math.random() * 150) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((25 + Math.random() * 180) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg',
      rating: Math.round((4.0 + Math.random() * 1.0) * 10) / 10,
      reviews: Math.floor(20 + Math.random() * 120),
      seller: 'Otobi Furniture',
      location: 'Dhaka, Bangladesh',
      badge: Math.random() > 0.7 ? ['Stylish', 'Modern', 'Decorative', 'Elegant'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Furniture',
      subcategory: 'Home Decor',
      description: `Beautiful ${name.toLowerCase()} to enhance your home`,
      features: ['Stylish Design', 'Quality Materials', 'Elegant Finish', 'Versatile Use'],
      inStock: Math.random() > 0.1
    });
  });

  // Manpower - Skilled Workers (25 products)
  const skilledWorkerNames = [
    'Skilled Electrician', 'Professional Plumber', 'Certified Carpenter', 'HVAC Technician',
    'Skilled Mason', 'Professional Welder', 'Certified Auto Mechanic', 'Industrial Machinist',
    'Skilled Painter', 'Professional Roofer', 'Certified CNC Operator', 'Skilled Fabricator',
    'Professional Tile Setter', 'Certified Forklift Operator', 'Skilled Landscaper', 'Professional Chef',
    'Certified Tailor', 'Skilled Upholsterer', 'Professional Locksmith', 'Certified Equipment Operator',
    'Skilled Glazier', 'Professional Pipefitter', 'Certified Rigger', 'Skilled Insulation Worker',
    'Professional Drywall Installer'
  ];

  skilledWorkerNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((15 + Math.random() * 35) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((20 + Math.random() * 40) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/8961251/pexels-photo-8961251.jpeg',
      rating: Math.round((4.0 + Math.random() * 1.0) * 10) / 10,
      reviews: Math.floor(15 + Math.random() * 100),
      seller: 'Bangladesh Manpower Agency',
      location: 'Dhaka, Bangladesh',
      badge: Math.random() > 0.7 ? ['Certified', 'Experienced', 'Skilled', 'Reliable'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Manpower',
      subcategory: 'Skilled Workers',
      description: `Experienced ${name.toLowerCase()} available for international placement`,
      features: ['Certified Professional', 'Experienced', 'English Speaking', 'Passport Ready'],
      inStock: Math.random() > 0.1
    });
  });

  // Manpower - Professional Services (20 products)
  const professionalServiceNames = [
    'Software Engineer', 'Civil Engineer', 'Mechanical Engineer', 'Electrical Engineer',
    'Architect', 'Accountant', 'Financial Analyst', 'HR Professional',
    'Marketing Specialist', 'Project Manager', 'Business Analyst', 'Data Scientist',
    'Nurse', 'Doctor', 'Pharmacist', 'Teacher',
    'Legal Consultant', 'Graphic Designer', 'Web Developer', 'IT Support Specialist'
  ];

  professionalServiceNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((25 + Math.random() * 75) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((35 + Math.random() * 85) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg',
      rating: Math.round((4.2 + Math.random() * 0.8) * 10) / 10,
      reviews: Math.floor(10 + Math.random() * 90),
      seller: 'Bangladesh Manpower Agency',
      location: 'Dhaka, Bangladesh',
      badge: Math.random() > 0.7 ? ['Qualified', 'Experienced', 'Professional', 'Certified'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Manpower',
      subcategory: 'Professional Services',
      description: `Highly qualified ${name.toLowerCase()} with proven experience`,
      features: ['Advanced Degree', 'Professional Certification', 'Industry Experience', 'English Proficient'],
      inStock: Math.random() > 0.1
    });
  });

  // Manpower - Labor Services (17 products)
  const laborServiceNames = [
    'Construction Worker', 'Factory Worker', 'Warehouse Worker', 'Cleaning Staff',
    'Security Guard', 'Driver', 'Gardener', 'Domestic Helper',
    'Hotel Staff', 'Restaurant Worker', 'Retail Worker', 'Farm Worker',
    'Caregiver', 'Janitor', 'Delivery Person', 'Maintenance Worker',
    'Packaging Worker'
  ];

  laborServiceNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((10 + Math.random() * 20) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((15 + Math.random() * 25) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/8961251/pexels-photo-8961251.jpeg',
      rating: Math.round((3.8 + Math.random() * 1.2) * 10) / 10,
      reviews: Math.floor(5 + Math.random() * 50),
      seller: 'Bangladesh Manpower Agency',
      location: 'Dhaka, Bangladesh',
      badge: Math.random() > 0.7 ? ['Trained', 'Hardworking', 'Reliable', 'Experienced'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Manpower',
      subcategory: 'Labor Services',
      description: `Reliable ${name.toLowerCase()} available for international placement`,
      features: ['Basic Training', 'Hardworking', 'Passport Ready', 'Medical Certified'],
      inStock: Math.random() > 0.1
    });
  });

  // Tourism - Tour Packages (20 products)
  const tourPackageNames = [
    'Sundarbans Mangrove Tour', 'Cox\'s Bazar Beach Holiday', 'Sylhet Tea Garden Tour', 'Dhaka City Tour',
    'Chittagong Hill Tracts Adventure', 'Bangladesh Heritage Tour', 'Srimangal Nature Retreat', 'Saint Martin Island Getaway',
    'Rangamati Lake Cruise', 'Paharpur Buddhist Monastery Tour', 'Kuakata Beach Excursion', 'Ratargul Swamp Forest Tour',
    'Bandarban Trekking Expedition', 'Mahasthangarh Archaeological Tour', 'Bagerhat Historical Tour', 'Lawachara Rainforest Trek',
    'Sonargaon Old Capital Tour', 'Sajek Valley Highland Tour', 'Tanguar Haor Wetland Expedition', 'Bangladesh River Cruise'
  ];

  tourPackageNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((150 + Math.random() * 500) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((200 + Math.random() * 600) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/3155666/pexels-photo-3155666.jpeg',
      rating: Math.round((4.2 + Math.random() * 0.8) * 10) / 10,
      reviews: Math.floor(10 + Math.random() * 100),
      seller: 'Bengal Tours & Travels',
      location: 'Dhaka, Bangladesh',
      badge: Math.random() > 0.7 ? ['All-Inclusive', 'Best Seller', 'Guided Tour', 'Family Friendly'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Tourism',
      subcategory: 'Tour Packages',
      description: `Comprehensive ${name.toLowerCase()} with professional guides and comfortable accommodations`,
      features: ['Professional Guide', 'Comfortable Accommodation', 'Transportation Included', 'Meals Provided'],
      inStock: Math.random() > 0.1
    });
  });

  // Tourism - Eco Tourism (15 products)
  const ecoTourismNames = [
    'Sundarbans Eco Tour', 'Lawachara Rainforest Eco Trek', 'Ratargul Swamp Forest Eco Tour', 'Tanguar Haor Eco Expedition',
    'Satchari National Park Eco Tour', 'Kaptai Lake Eco Cruise', 'Madhupur Forest Eco Trek', 'Nijhum Dwip Eco Tour',
    'Baikka Beel Wetland Eco Tour', 'Himchari National Park Eco Trek', 'Inani Beach Eco Tour', 'Khadimnagar Rainforest Eco Trek',
    'Pablakhali Wildlife Sanctuary Eco Tour', 'Teknaf Wildlife Sanctuary Eco Trek', 'Dulahazara Safari Park Eco Tour'
  ];

  ecoTourismNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((180 + Math.random() * 400) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((220 + Math.random() * 450) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/5257587/pexels-photo-5257587.jpeg',
      rating: Math.round((4.3 + Math.random() * 0.7) * 10) / 10,
      reviews: Math.floor(8 + Math.random() * 80),
      seller: 'Bengal Tours & Travels',
      location: 'Dhaka, Bangladesh',
      badge: Math.random() > 0.7 ? ['Sustainable', 'Eco-Friendly', 'Wildlife', 'Nature'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Tourism',
      subcategory: 'Eco Tourism',
      description: `Sustainable ${name.toLowerCase()} focused on environmental conservation and local communities`,
      features: ['Sustainable Practices', 'Local Community Support', 'Wildlife Conservation', 'Small Group Size'],
      inStock: Math.random() > 0.1
    });
  });

  // Tourism - Cultural Tours (10 products)
  const culturalTourNames = [
    'Bangladesh Heritage Tour', 'Old Dhaka Cultural Tour', 'Paharpur Buddhist Monastery Tour', 'Mahasthangarh Archaeological Tour',
    'Sonargaon Old Capital Tour', 'Bagerhat Historical Tour', 'Rajshahi Silk Route Tour', 'Chittagong Cultural Heritage Tour',
    'Mainamati Buddhist Ruins Tour', 'Kantajew Temple Cultural Tour'
  ];

  culturalTourNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((120 + Math.random() * 350) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((150 + Math.random() * 400) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/3889843/pexels-photo-3889843.jpeg',
      rating: Math.round((4.4 + Math.random() * 0.6) * 10) / 10,
      reviews: Math.floor(12 + Math.random() * 90),
      seller: 'Bengal Tours & Travels',
      location: 'Dhaka, Bangladesh',
      badge: Math.random() > 0.7 ? ['Cultural', 'Historical', 'Educational', 'Authentic'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Tourism',
      subcategory: 'Cultural Tours',
      description: `Immersive ${name.toLowerCase()} exploring Bangladesh's rich cultural heritage`,
      features: ['Expert Cultural Guide', 'Historical Sites', 'Local Cuisine', 'Traditional Experiences'],
      inStock: Math.random() > 0.1
    });
  });

  // Freelancer - IT & Programming (35 products)
  const itProgrammingNames = [
    'Web Development Services', 'Mobile App Development', 'WordPress Development', 'E-commerce Development',
    'Custom Software Development', 'Frontend Development', 'Backend Development', 'Full Stack Development',
    'UI/UX Development', 'React Development', 'Angular Development', 'Vue.js Development',
    'Node.js Development', 'PHP Development', 'Python Development', 'Java Development',
    'C# Development', '.NET Development', 'Database Development', 'API Development',
    'DevOps Services', 'Cloud Computing Services', 'Blockchain Development', 'AI & Machine Learning',
    'Game Development', 'QA & Testing Services', 'IT Consulting', 'Technical Support',
    'Bug Fixing Services', 'Code Review Services', 'IT Security Services', 'CMS Development',
    'Shopify Development', 'Magento Development', 'WooCommerce Development'
  ];

  itProgrammingNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((20 + Math.random() * 100) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((30 + Math.random() * 120) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/574071/pexels-photo-574071.jpeg',
      rating: Math.round((4.2 + Math.random() * 0.8) * 10) / 10,
      reviews: Math.floor(15 + Math.random() * 150),
      seller: 'BD Freelancers Hub',
      location: 'Dhaka, Bangladesh',
      badge: Math.random() > 0.7 ? ['Top Rated', 'Expert', 'Fast Delivery', 'Best Value'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Freelancer',
      subcategory: 'IT & Programming',
      description: `Professional ${name.toLowerCase()} by experienced developers`,
      features: ['Expert Developers', 'Quality Code', 'On-time Delivery', 'Post-delivery Support'],
      inStock: Math.random() > 0.1
    });
  });

  // Freelancer - Design & Creative (30 products)
  const designCreativeNames = [
    'Logo Design', 'Brand Identity Design', 'Graphic Design Services', 'Web Design',
    'UI/UX Design', 'Mobile App Design', 'Social Media Design', 'Banner Design',
    'Poster Design', 'Flyer Design', 'Brochure Design', 'Business Card Design',
    'Packaging Design', 'Label Design', 'Book Cover Design', 'Album Cover Design',
    'T-shirt Design', 'Illustration Services', 'Character Design', 'Icon Design',
    'Infographic Design', 'PowerPoint Design', 'Animation Services', '3D Modeling',
    'Video Editing', 'Photo Editing', 'Product Photography', 'Portrait Photography',
    'Interior Design', 'Architectural Visualization'
  ];

  designCreativeNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((15 + Math.random() * 85) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((25 + Math.random() * 100) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/326501/pexels-photo-326501.jpeg',
      rating: Math.round((4.3 + Math.random() * 0.7) * 10) / 10,
      reviews: Math.floor(20 + Math.random() * 180),
      seller: 'BD Freelancers Hub',
      location: 'Dhaka, Bangladesh',
      badge: Math.random() > 0.7 ? ['Creative', 'Professional', 'Unique', 'Custom'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Freelancer',
      subcategory: 'Design & Creative',
      description: `Creative ${name.toLowerCase()} tailored to your brand and vision`,
      features: ['Custom Design', 'Unlimited Revisions', 'Source Files Included', 'Fast Turnaround'],
      inStock: Math.random() > 0.1
    });
  });

  // Freelancer - Digital Marketing (27 products)
  const digitalMarketingNames = [
    'SEO Services', 'Social Media Marketing', 'Content Marketing', 'Email Marketing',
    'PPC Advertising', 'Google Ads Management', 'Facebook Ads Management', 'Instagram Marketing',
    'LinkedIn Marketing', 'Twitter Marketing', 'YouTube Marketing', 'TikTok Marketing',
    'Influencer Marketing', 'Affiliate Marketing', 'Content Writing', 'Blog Writing',
    'Copywriting', 'Technical Writing', 'Product Description Writing', 'Press Release Writing',
    'Market Research', 'Competitor Analysis', 'Digital Marketing Strategy', 'Brand Awareness Campaign',
    'Lead Generation Campaign', 'Conversion Rate Optimization', 'Web Analytics Services'
  ];

  digitalMarketingNames.forEach((name, index) => {
    products.push({
      id: (productId++).toString(),
      name,
      price: Math.round((25 + Math.random() * 150) * 100) / 100,
      originalPrice: Math.random() > 0.6 ? Math.round((40 + Math.random() * 180) * 100) / 100 : undefined,
      image: 'https://images.pexels.com/photos/905163/pexels-photo-905163.jpeg',
      rating: Math.round((4.1 + Math.random() * 0.9) * 10) / 10,
      reviews: Math.floor(10 + Math.random() * 120),
      seller: 'BD Freelancers Hub',
      location: 'Dhaka, Bangladesh',
      badge: Math.random() > 0.7 ? ['Results Driven', 'Data-Focused', 'ROI Optimized', 'Strategic'][Math.floor(Math.random() * 4)] : undefined,
      category: 'Freelancer',
      subcategory: 'Digital Marketing',
      description: `Effective ${name.toLowerCase()} to grow your online presence and business`,
      features: ['Targeted Campaigns', 'Performance Tracking', 'Regular Reporting', 'Strategy Optimization'],
      inStock: Math.random() > 0.1
    });
  });

  return products;
};

export const products: Product[] = generateProducts();

// Helper functions
const getProductsByCategory = (categorySlug: string): Product[] => {
  return products.filter(product => 
    product.category.toLowerCase().replace(/\s+/g, '-').replace(/&/g, '') === categorySlug
  );
};

const getProductsBySubcategory = (subcategorySlug: string): Product[] => {
  return products.filter(product => 
    product.subcategory.toLowerCase().replace(/\s+/g, '-').replace(/&/g, '') === subcategorySlug
  );
};

const getProductById = (id: string): Product | undefined => {
  return products.find(product => product.id === id);
};

export const getProductsBySeller = (sellerSlug: string): Product[] => {
  return products.filter(product => 
    product.seller.toLowerCase().replace(/\s+/g, '-').replace(/\./g, '') === sellerSlug
  );
};

export const getSellerBySlug = (slug: string): Seller | undefined => {
  return sellers.find(seller => seller.slug === slug);
};

export const getFeaturedProducts = (limit: number = 8): Product[] => {
  return products
    .filter(product => product.badge)
    .slice(0, limit);
};

const getRelatedProducts = (productId: string, limit: number = 4): Product[] => {
  const product = getProductById(productId);
  if (!product) return [];
  
  return products
    .filter(p => p.id !== productId && p.category === product.category)
    .slice(0, limit);
};